<template>
  <batch-upload-file lob="IE" />
</template>

<script>
import batchUploadFile from '@/components/Cargo/FileUpload/batchUploadFile'
export default {
  name: 'IEBatchUploadFile',
  components: { batchUploadFile }
}
</script>

<style scoped>

</style>
